import api from './axios';
import type { LoginData, User } from '../types';

// Re-export types for runtime compatibility
export type { LoginData, User } from '../types';

export const authApi = {
  login: async (data: LoginData) => {
    const response = await api.post('/auth/login', data);
    return response.data;
  },

  loginWithMicrosoft: async (idToken: string) => {
    const response = await api.post('/auth/microsoft', { id_token: idToken });
    return response.data;
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await api.get('/auth/me');
    return response.data;
  },
};
